import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import ExploreSettings from './ExploreSettings';
import PreviewModal from './PreviewModal/PreviewModal';
import submit from './submit';
import validate from './validate';
import { getIOSTheme } from '../../../helpers/iOSthemeLayoutHelper/iOSImageOrder';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';
import cp from '../../../components/commonStyle.css';
import s from './IOSLayoutSettingsForm.css';
import messages from '../../../locale/jsonMessages';

class IOSLayoutSettingsForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      themes: [],
      title: null
    }
  }

  themeOptions = ({ name, label, themeType }) => {
    const { formatMessage } = this.props.intl;
    return (
      <>
        <ControlLabel className={cx('commonLabelText', s.spaceMarginBottom0)}>
          {label}
        </ControlLabel>
        <Field name={name} type="text" inputClass='commonSelectField' component={CommonFormComponent}>
          <option value={1}>{formatMessage(messages.theme1)}</option>
          <option value={2}>{formatMessage(messages.theme2)}</option>
          <option value={3}>{formatMessage(messages.theme3)}</option>
          <option value={4}>{formatMessage(messages.theme4)}</option>
        </Field>
        <div>
          <span className={s.iosPreviewLink} onClick={() => this.openPreviewModal({ name, themeType, label })}>
            {formatMessage(messages.preview)}
          </span>
        </div>
      </>
    )
  }


  openPreviewModal = ({ name, themeType, label }) => {
    const themes = getIOSTheme({ themeType, name })
    this.setState({ showModal: true, themes, title: label });
  }

  closePreviewModal = () => {
    this.setState({ showModal: false, themes: [] });
  }

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { themeType, onBoardPage, loginPage, buttonType, inputType, forgotPassword, viewCar, profile, wishlist } = this.props;
    const { formatMessage } = this.props.intl;
    const { showModal, themes, title } = this.state;
    const themeData = [
      { name: 'themeType', label: formatMessage(messages.themeType), themeType: themeType },
      { name: 'onBoardPage', label: formatMessage(messages.onBoardPage), themeType: onBoardPage },
      { name: 'loginPage', label: formatMessage(messages.loginPage), themeType: loginPage },
      { name: 'forgotPassword', label: formatMessage(messages.forgotResetPassword), themeType: forgotPassword },
      { name: 'buttonType', label: formatMessage(messages.buttonType), themeType: buttonType },
      { name: 'inputType', label: formatMessage(messages.inputType), themeType: inputType },
      { name: 'viewCar', label: formatMessage(messages.viewCarLayout), themeType: viewCar },
      { name: 'profile', label: formatMessage(messages.profileLayout), themeType: profile },
      { name: 'wishlist', label: formatMessage(messages.wishlistLayout), themeType: wishlist },
    ];
    return (
      <div>
        <PreviewModal
          show={showModal}
          closePreviewModal={this.closePreviewModal}
          openPreviewModal={this.openPreviewModal}
          themes={themes}
          title={title}
        />
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.appLayoutSettings} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{error}</strong>}
          <div className='siteAdminCenterContainerBox'>
            <div className={cx(cp.spaceBottom4, 'tooltipLabelContainer')}>
              <span className={cx(cp.fontWeightBold, cp.commonSubTitleText)}><FormattedMessage  {...messages.themeSettings} /></span>
              <ToolTipSection label={formatMessage(messages.themeSettingsToolTip)} />
            </div>
            <div className='oneColumnGrid'>
              {
                themeData?.map((item, key) => {
                  return (
                    <div className={s.themeRowContainer} key={key}>
                      {this.themeOptions(item)}
                    </div>
                  )
                })
              }
            </div>
            <hr className={s.adminHorizontalDevided} />
            <ExploreSettings />
          </div>
          <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cp.btnPrimary} type="submit" disabled={submitting} ><FormattedMessage  {...messages.save} /></Button>
          </div>
        </form>
      </div >
    );
  }
}

const selector = formValueSelector('IOSLayoutSettingsForm'); // <-- same as form name

IOSLayoutSettingsForm = reduxForm({
  form: 'IOSLayoutSettingsForm', // a unique name for this form
  validate
})(IOSLayoutSettingsForm);

const mapState = (state) => ({
  themeType: selector(state, 'themeType'),
  onBoardPage: selector(state, 'onBoardPage'),
  loginPage: selector(state, 'loginPage'),
  buttonType: selector(state, 'buttonType'),
  inputType: selector(state, 'inputType'),
  forgotPassword: selector(state, 'forgotPassword'),
  viewCar: selector(state, 'viewCar'),
  profile: selector(state, 'profile'),
  wishlist: selector(state, 'wishlist')
});

const mapDispatch = {};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(IOSLayoutSettingsForm)));
